<div class="header">
  <button (click)="close()" class="popup-close-button" tabindex="0"></button>
  <h2 class="title">{{title}}</h2>
</div>
<div class="body">
  <div class="table-container">
    <table class="display" id="complianceDetailsTable"></table>
  </div>
</div>